import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type IClickToText } from 'entities/ClickToText'
import { ClickToTextRoutes } from 'pages/clickToText'
import { ClickToTextActionsStore } from 'pages/clickToText/pages/all/store'

export const clickToTextActionsStore = new ClickToTextActionsStore()

const clickToTextActions = {
  detail: (clickToText: IClickToText, entities?: IEntitiesStore): ActionItem => ({
    icon: 'eye',
    onAction: () => {
      if (entities) {
        const { eventLogStore, organizationStore } = entities
        eventLogStore.logEvent(
          'Click to Text Used',
          {
            event_id: 'click_to_text_used',
            action: 'Details clicked',
            linkId: clickToText.id,
            agencyId: organizationStore.agency_id,
          },
          { groupId: organizationStore.id }
        )
      }
      clickToTextActionsStore.onDetails(clickToText)
    },
    text: 'Details',
  }),
  edit: (clickToText: IClickToText, entities?: IEntitiesStore): ActionItem => ({
    icon: 'edit',
    onAction: () => {
      if (entities) {
        const { eventLogStore, organizationStore } = entities
        eventLogStore.logEvent(
          'Click to Text Used',
          {
            event_id: 'click_to_text_used',
            action: 'Edit clicked',
            linkId: clickToText.id,
            agencyId: organizationStore.agency_id,
          },
          { groupId: organizationStore.id }
        )
      }
      uiStore.changeRoute({
        path: `/${ClickToTextRoutes.root}/${ClickToTextRoutes.edit}/${clickToText.id}`,
      })
    },
    text: 'Edit',
  }),
  duplicate: (clickToText: IClickToText, entities?: IEntitiesStore): ActionItem => ({
    icon: 'copy',
    onAction: () => {
      if (entities) {
        const { eventLogStore, organizationStore } = entities
        eventLogStore.logEvent(
          'Click to Text Used',
          {
            event_id: 'click_to_text_used',
            action: 'Duplicate clicked',
            linkId: clickToText.id,
            agencyId: organizationStore.agency_id,
          },
          { groupId: organizationStore.id }
        )
      }
      uiStore.changeRoute({
        path: `/${ClickToTextRoutes.root}/${ClickToTextRoutes.clone}/${clickToText.id}`,
      })
    },
    text: 'Duplicate',
  }),
  delete: (
    clickToText: IClickToText,
    onSuccess?: () => void,
    entities?: IEntitiesStore
  ): ActionItem => ({
    icon: 'delete',
    onAction: () => {
      if (entities) {
        const { eventLogStore, organizationStore } = entities
        eventLogStore.logEvent(
          'Click to Text Used',
          {
            event_id: 'click_to_text_used',
            action: 'Delete clicked',
            linkId: clickToText.id,
            agencyId: organizationStore.agency_id,
          },
          { groupId: organizationStore.id }
        )
      }
      clickToTextActionsStore.onDelete(clickToText, onSuccess)
    },
    text: 'Delete',
  }),
}

export const getClickToTextActions = ({
  clickToText,
  onSuccessDelete,
  entities,
}: {
  clickToText: IClickToText
  onSuccessDelete?: () => void
  entities?: IEntitiesStore
}): ActionItem[] => {
  return [
    clickToTextActions.detail(clickToText, entities),
    clickToTextActions.edit(clickToText, entities),
    clickToTextActions.duplicate(clickToText, entities),
    clickToTextActions.delete(clickToText, onSuccessDelete, entities),
  ]
}
